import React from 'react';
import PropTypes from 'prop-types';

import { UncontrolledTable } from '~/components';

const AllergyTable = ({
  columns,
  defaultSorted,
  params,
  ...rest
}) => (
  <UncontrolledTable
    name="allergy"
    endpoint={{
      url: 'data/public/nav-list-view-allergy',
      params,
    }}
    columns={columns}
    defaultSorted={defaultSorted}
    {...rest}
  />
);

AllergyTable.propTypes = {
  params: PropTypes.shape(),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  defaultSorted: PropTypes.arrayOf(PropTypes.shape()),
};

AllergyTable.defaultProps = {
  params: {},
  columns: [{
    id: 'allergyLabel',
    Header: 'Allergy',
    accessor: 'attributes.allergyLabel',
  }, {
    id: 'medicationLabel',
    Header: 'Medication',
    accessor: 'attributes.medicationLabel',
  }, {
    id: 'comments',
    Header: 'Comments',
    accessor: 'attributes.comments',
  }],
  defaultSorted: [{ id: 'allergyLabel' }],
};

export default AllergyTable;
